var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"accept":_vm.type,"label":"File input"},on:{"change":function($event){return _vm.changeData($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }